import PropTypes from "prop-types";
import React from "react";
import {
	StyleSheet
} from "react-native";

import StyledText from "./StyledText";

import Style from "ae-style";

var styles = StyleSheet.create({
	link: {
		color: Style.colors.grayblue
	},
	contrast: {
		color: Style.colors.lightBlue
	}
});

export default function Link(props, context){
	var dispatch = context.dispatch;
	var title = props.title || props.children;
	var uri = props.uri;
	var openLink = dispatch("linkopener:trigger:open", uri);

	var style = styles.link;
	if(props.contrast)
		style = styles.contrast;

	return (
		<StyledText id={props.id} style={style} onPress={openLink}>{title}</StyledText>
	);
}

Link.contextTypes = {
	dispatch: PropTypes.func
};
